export const VISUAL_GAME_REFRESH_LOCK = 'voko.visual-game.auth.refresh'
const REFRESH_LOCK_WAIT_MS = 15_000

export function visualGameRefreshLockName() {
  // 同源凭据只有一个刷新临界区；epoch 用于拒绝旧会话结果，不用于拆分互斥锁。
  return VISUAL_GAME_REFRESH_LOCK
}

export function newVisualGameSessionEpoch() {
  if (typeof globalThis.crypto?.randomUUID === 'function') return globalThis.crypto.randomUUID()
  return Array.from(globalThis.crypto.getRandomValues(new Uint8Array(16)), value => value.toString(16).padStart(2, '0')).join('')
}

/** Epochs identify explicit login/logout; rotating a token pair keeps its epoch. */
export function refreshSessionTransition(observed, current) {
  if (observed.epoch !== current.epoch) return 'session_changed'
  if (observed.access_token === current.access_token && observed.refresh_token === current.refresh_token) return 'unchanged'
  return current.access_token && current.refresh_token ? 'rotated' : 'session_changed'
}

/** A local transition must not become an old HTTP 401 that expires a newer login. */
export function refreshSessionChanged() {
  const error = new Error('auth_session_changed')
  error.code = 'AUTH_SESSION_CHANGED'
  return error
}

/** 没有跨文档互斥就不能安全消费一次性 refresh；禁止降级成各实例自行 POST。 */
export async function withVisualGameRefreshLock(work, { timeout_ms = REFRESH_LOCK_WAIT_MS } = {}) {
  const locks = globalThis.navigator?.locks
  if (typeof locks?.request !== 'function') {
    const error = new Error('auth_refresh_lock_unavailable')
    error.code = 'AUTH_REFRESH_LOCK_UNAVAILABLE'
    throw error
  }
  const waiting = new AbortController()
  const timer = setTimeout(() => {
    const error = new Error('auth_refresh_lock_timeout')
    error.code = 'AUTH_REFRESH_LOCK_TIMEOUT'
    waiting.abort(error)
  }, timeout_ms)
  try {
    return await locks.request(visualGameRefreshLockName(), { mode: 'exclusive', signal: waiting.signal }, () => {
      clearTimeout(timer)
      if (waiting.signal.aborted) throw waiting.signal.reason
      return work()
    })
  } catch (error) {
    if (waiting.signal.aborted) throw waiting.signal.reason
    throw error
  } finally { clearTimeout(timer) }
}
